import React, { useMemo } from 'react';

import { Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LoadingPage, RecordContextProvider, useRedirect } from 'react-admin';

import { useParams } from 'react-router-dom';

import PepMatchInformation from './PepMatchInformation';

import useEntityData from '../../../../../../hooks/useEntityData';
import { PepMatches } from '../../../../../../utilities/schemas/pepMatches';
import actions from '../../../../../../constants/actions';
import PepAbout from './PepAbout';
import PepRoles from './PepRoles';
import PepNationalIdentifiers from './PepNationalIdentifiers';
import PepImages from './PepImages';
import PepSources from './PepSources';
import PepRelatedEntities from './PepRelatedEntities';

const GoBackButton = () => {
  const redirect = useRedirect();

  return (
    <IconButton
      onClick={() => { redirect('..'); }}
      size="small"
    >
      <ArrowBackIosIcon color="inherit" fontSize="medium" />
    </IconButton>
  );
};

const PepDetails = () => {
  const {
    data,
    isLoading,
  } = useEntityData<PepMatches>({
    source: 'pep',
    getAction: actions.INDIVIDUAL_GET_PEP,
  });

  const { pepId } = useParams();

  const currentPep = useMemo(
    () => data?.potentialMatches.find((match) => match._id === pepId),
    [data, pepId],
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <RecordContextProvider value={{ ...currentPep, providerName: data?.providerName }}>
      <Grid container spacing={6}>
        <Grid size={12}>
          <GoBackButton />
        </Grid>
        <Grid size={12}>
          <Grid container spacing={6}>
            <Grid size={12}>
              <PepMatchInformation />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <PepAbout />
                </Grid>
                <Grid size={12}>
                  <PepNationalIdentifiers />
                </Grid>
                <Grid size={12}>
                  <PepImages />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <PepRoles />
                </Grid>
                <Grid size={12}>
                  <PepRelatedEntities />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <PepSources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RecordContextProvider>
  );
};

export default PepDetails;
